<template>
  <div>
    <div v-if="$auth.policies['view-bank-account-list']">
      <div class="pa-4 d-flex justify-space-between align-center">
        <div>
          <Breadcrumbs
            :headline="route.meta.title"
            :link="[{ text: 'Tài chính', href: '#' }, { text: route.meta.title }]"
          />
        </div>
        <v-btn class="mx-1 mt-2" depressed dark color="#0D47A1" @click="openDialog">
          <v-icon left>mdi-file-download-outline</v-icon>
          Nhập Excel
        </v-btn>
      </div>
      <v-card outlined class="pa-6 mx-4 mb-6 elevation-0">
        <BankFilter />
      </v-card>
      <v-card outlined class="mx-4 elevation-0">
        <ListBankAccount />
      </v-card>
    </div>
    <div v-else>
      <Page403></Page403>
    </div>
    <DialogUploadExcel ref="dialog-excel" />
  </div>
</template>
<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import BankFilter from '@/modules/tuitionFee/bank-account/BankFilter'
import ListBankAccount from '@/modules/tuitionFee/bank-account/ListBankAccount'
import DialogUploadExcel from '@/modules/tuitionFee/bank-account/DialogUploadExcel.vue'
import utils from '@/plugins/utils'
import { textHelpers } from '@/helpers/TextHelper.js'
import { mapActions, mapState } from 'vuex'
import Page403 from '@/views/Page403.vue'
export default {
  components: {
    Breadcrumbs,
    BankFilter,
    ListBankAccount,
    DialogUploadExcel,
    Page403,
  },
  computed: {
    ...mapState('tuitionFeeGroup', ['tuitionFeeGroups', 'tuitionFeeSearchParams']),
    route() {
      return this.$route
    },
    type() {
      if (this.route.name === 'TuitionFeeGroup') return 'normal'
      else return 'priority'
    },
  },
  methods: {
    ...mapActions('tuitionFeeGroup', ['fetchGroups']),
    async exportExcel() {
      this.$loading.active = true
      try {
        let headers = [...this.$refs.tuitionFeeGroupTable.headers]
        let excelHeader = headers.map(({ text, value }) => ({ text, value }))
        excelHeader = excelHeader.filter(excel => excel.value !== 'action')
        const list = await this.fetchGroups({
          ...this.tuitionFeeSearchParams,
          type: this.type,
          _sort: 'createdAt:desc',
          _limit: -1,
        })
        const tuitionFeeGroups = JSON.parse(JSON.stringify(list))
        const data = tuitionFeeGroups.map(item => {
          item.category = textHelpers.getCategory(item.category)
          return item
        })
        utils.exportExcel(data, excelHeader, `Danh sách ${this.route.meta.title}`)
      } catch (error) {
        this.$alert.error('Đã có lỗi xảy ra: ' + error)
      } finally {
        this.$loading.active = false
      }
    },
    openDialog() {
      this.$refs['dialog-excel'].openDialog()
    },
  },
}
</script>
<style scoped>
td {
  white-space: nowrap !important;
}
</style>
